
const countries = {
    "Germany": (
        <div>
            <h5>Bonn-Rheinback</h5>
            <b>What is their project about?</b>
            <div>Reduce CO2 emissions using cyanobacteria to produce biofuel used for airplanes.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-bonn-rheinback.png"/>
            <h5>Dusseldorf</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Their project is a snthetic biology solution in space!</div>
            <br />
            <b>What is their project about?</b>
            <div>Solving the limited lifetime of spacecraft equipment.</div>
            <br />
            <h5>Munich</h5>
            <b>What is an interesting fact about their team?</b>
            <div>During our meeting, we got to meet some great individuals responsible for very different tasks on their team, so the meeting was very open and fluid.</div>
            <br />
            <b>What is their project about?</b>
            <div>Cell therapy using quorum sensing on tumor cells.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-munich.png"/>
        </div>
    ),
    "Sweden": (
        <div>
            <h5>Lund</h5>
            <b>What is an interesting fact about their team?</b>
            <div>iGEM is associated with a course, so members are also learning at a university level about what they’re performing and researching for iGEM!</div>
            <br />
            <b>What is their project about?</b>
            <div>Enhance and enrich the growth of bees to decrease species vulnerability.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-lund.png"/>
        </div>
    ),
    "Denmark": (
        <div>
            <h5>UCPH - Copenhagen</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Many of their team members are international students, coming from various geographical backgrounds!</div>
            <br />
            <b>What is their project about?</b>
            <div>Biodegradable fishnets made of spider silk and a combination of strength proteins.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-copenhagen.png"/>
        </div>
    ),
    "Greece": (
        <div>
            <h5>Thessaloniki</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Their entire team is generally brand new each year!</div>
            <br />
            <b>What is their project about?</b>
            <div>“Theranostics” tool for glioblastoma treatment and diagnosis.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-thessaloniki.png"/>
            <h5>Patras</h5>
            <b>What is an interesting fact about their team?</b>
            <div>iGEM is very popular in Patras, and their team is looking to spread it even more!</div>
            <br />
            <b>What is their project about?</b>
            <div>Develop a method to detect early stages of lung cancer via liquid biopsies.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-patras.png"/>
        </div>
    ),
    "England": (
        <div>
            <h5>Exeter</h5>
            <b>What is an interesting fact about their team?</b>
            <div>We collaborated on problems we have faced and bounced solutions off of one another!</div>
            <br />
            <b>What is their project about?</b>
            <div>Their team’s project is about - Electroconductive synthesized spider silk for biocompatible applications, like tendon injury rehabilitation.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-exeter.png"/>
        </div>
    ),
    "France": (
        <div>
            <h5>Grenoble</h5>
            <b>What is an interesting fact about their team?</b>
            <div>We conversed in our meetings about our last year’s project, which used microfluidic devices. Their team was interested in collaborating with the Math & Modeling sub-team for design concepts on this device!</div>
            <br />
            <b>What is their project about?</b>
            <div>Use of magnet detected bacteria to detect copper in patients through a microfluidic device.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-grenoble.png"/>
            <h5>Toulouse</h5>
            <b>What is an interesting fact about their team?</b>
            <div>iGEM is considered an internship, so the members are extra dedicated to their work and research!</div>
            <br />
            <b>What is their project about?</b>
            <div>Detecting allergies via bacterial recognition of specific IgE.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-toulouse.png"/>
        </div>
    ),
    "Spain": (
        <div>
            <h5>Navarra</h5>
            <b>What is an interesting fact about their team?</b>
            <div>An interesting fact about their team is - This is their second time in iGEM as a team!</div>
            <br />
            <b>What is their project about?</b>
            <div>Using tryptophan from agricultural byproducts and converting to serotonin for assistance with serotonin-related mental illnesses.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-navarra.png"/>
        </div>
    ),
    "Canada": (
        <div>
            <h5>McMaster</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Our team collaborated on visuals for a children’s book with McMaster!</div>
            <br />
            <b>What is their project about?</b>
            <div>Use of biomarkers to indicate the risk of cancer.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-mcmaster.png"/>
            <h5>McGill</h5>
            <b>What is an interesting fact about their team?</b>
            <div>They collaborated with Concordia to hold a Mini-Jamb in Montreal for other Canadian teams!</div>
            <br />
            <b>What is their project about?</b>
            <div>Mini bioreactor that removes excess cholesterol from the body.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-mcgill.png"/>
            <h5>Guelph</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Their wiki design lead showed great interest in our last year’s wiki design, and showed interest in sharing insight with our wiki design team!</div>
            <br />
            <b>What is their project about?</b>
            <div>All tomato plant’s roots to fight off fungus gnats which cause problems.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-guelph.png"/>
            <h5>UBC</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Their project works on creating heat resilient crops, which is important for Canada’s temperate climate!</div>
            <br />
            <b>What is their project about?</b>
            <div>Create genetic factors in crops to allow for heat resilience in warmer climates.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-ubc.png"/>
            <h5>UBCO</h5>
            <b>What is an interesting fact about their team?</b>
            <div>First year this team is running iGEM alone! Additionally, they were able to provide us with a list of stakeholder’s to reach out to in Western Canada!</div>
            <br />
            <b>What is their project about?</b>
            <div>Use auto-bioluminescent cyanobacteria to emit light to limit blue light pollution.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-ubco.png"/>
        </div>
    ),
    "USA": (
        <div>
            <h5>Washington</h5>
            <b>What is an interesting fact about their team?</b>
            <div>The structure of their team is nearly identical to ours! (They’re also called UW iGEM!)</div>
            <br />
            <b>What is their project about?</b>
            <div>“Test stickers” to test for skin cancer.</div>
            <br />
            <img width="100%" style={{marginBottom: "5vh"}} alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-washington.png"/>
            <h5>Lambert High School</h5>
            <b>What is an interesting fact about their team?</b>
            <div>The only high school we interviewed, and collaborated with us for a “heart-friendly” cookbook!</div>
            <br />
            <b>What is their project about?</b>
            <div>Use a reporting mechanism to detect the miRNA concentrations associated with coronary heart disease.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-lambert-high.png"/>
        </div>
    ),
    "Mexico": (
        <div>
            <h5>Tec Chicuahua</h5>
            <b>What is an interesting fact about their team?</b>
            <div>They’re working on a comic book strip about different team’s projects aimed at ages 6-12 years of age!</div>
            <br />
            <b>What is their project about?</b>
            <div>Creation and use of bio-silencer to silence attacks of crops that are essential to their economy!</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-tec-chihuahua.png"/>
        </div>
    ),
    "Hong Kong": (
        <div>
            <h5>CityU</h5>
            <b>What is an interesting fact about their team?</b>
            <div>Their team requires you to be in a chemistry major program to be part of iGEM, meaning they’re all rising experts in chemistry and related fields!</div>
            <br />
            <b>What is their project about?</b>
            <div>Enhance the anti-cancer agents in fungus for treatment.</div>
            <br />
            <img width="100%" alt="cityu" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-cityu.png"/>
        </div>
    ),
    "India": (
        <div>
            <h5>REC CHENNAI</h5>
            <b>What is an interesting fact about their team?</b>
            <div>This team ran an informative conference in August to raise awareness about the problem their project aims to solve!</div>
            <br />
            <b>What is their project about?</b>
            <div>Use genetically modified E-Coli to remove heavy metals from water supply’s.</div>
            <br />
            <img width="100%" alt="collab" src="https://static.igem.wiki/teams/4393/wiki/collaborations/collab-rec-chennai.png"/>
        </div>
    ),
}

export default countries